// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"db61286e","568":"ebdaa9dc"}[chunkId] + ".chunk.js";
};